// ========================================
// DÉPLACEMENT SÉLECTEUR DE DEVISE VERS HEADER
// ========================================

(function() {
  'use strict';
  
  // Configuration
  const CONFIG = {
    MOBILE_BREAKPOINT: 768,
    SELECTORS: {
      PANEL_LOCALIZATION: '.panel-footer__localization-wrapper .relative',
      PANEL_LOCALE: '.panel-footer__localization-wrapper .relative',
      HEADER_LOCALIZATION: '.header__localization',
      HEADER_WRAPPER: '.header__wrapper',
      HEADER_MAIN_NAV: '.header__main-nav',
      HEADER_ICON_LIST: '.header__main-nav .header__icon-list',
      HEADER_SECONDARY_NAV: '.header__secondary-nav',
      HEADER_SECONDARY_ICON_LIST: '.header__secondary-nav .header__icon-list',
      HAMBURGER_ICON: 'button[aria-controls="header-sidebar-menu"]',
      CART_ICON: 'a[href*="cart"], a[href*="panier"]',
      PANEL_WRAPPER: '.panel-footer__localization-wrapper'
    }
  };
  
  // Fonction pour attendre qu'un élément soit disponible
  function waitForElement(selector, timeout = 5000) {
    return new Promise((resolve, reject) => {
      const element = document.querySelector(selector);
      if (element) {
        resolve(element);
        return;
      }
      
      const observer = new MutationObserver((mutations, obs) => {
        const element = document.querySelector(selector);
        if (element) {
          obs.disconnect();
          resolve(element);
        }
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      setTimeout(() => {
        observer.disconnect();
        reject(new Error(`Element ${selector} not found after ${timeout}ms`));
      }, timeout);
    });
  }
  
  // Fonction pour cloner un sélecteur avec des IDs uniques
  function cloneSelectorWithUniqueIds(selector, prefix) {
    const cloned = selector.cloneNode(true);
    
    // Générer un ID unique pour le popover
    const popover = cloned.querySelector('x-popover');
    if (popover) {
      const uniqueId = prefix + '-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
      popover.id = uniqueId;
      
      // Mettre à jour l'aria-controls du bouton
      const button = cloned.querySelector('button');
      if (button) {
        button.setAttribute('aria-controls', uniqueId);
      }
    }
    
    return cloned;
  }
  
  // Fonction pour déplacer le sélecteur de devise
  async function moveLocalizationToHeader() {
    if (window.innerWidth > CONFIG.MOBILE_BREAKPOINT) {
      return;
    }
    
    try {
      const panelWrapper = await waitForElement(CONFIG.SELECTORS.PANEL_WRAPPER);
      const headerMainNav = await waitForElement(CONFIG.SELECTORS.HEADER_MAIN_NAV);
      const headerIconList = await waitForElement(CONFIG.SELECTORS.HEADER_ICON_LIST);
      const headerSecondaryNav = await waitForElement(CONFIG.SELECTORS.HEADER_SECONDARY_NAV);
      const headerSecondaryIconList = await waitForElement(CONFIG.SELECTORS.HEADER_SECONDARY_ICON_LIST);
      
      if (panelWrapper && headerMainNav && headerSecondaryNav) {
        // Récupérer tous les sélecteurs
        const allSelectors = panelWrapper.querySelectorAll('.relative');
        const countrySelector = Array.from(allSelectors).find(el => 
          el.querySelector('button[aria-label*="pays"]') || 
          el.querySelector('button[aria-label*="country"]') ||
          el.textContent.includes('EUR') || 
          el.textContent.includes('€')
        );
        
        const localeSelector = Array.from(allSelectors).find(el => 
          el.querySelector('button[aria-label*="langue"]') || 
          el.querySelector('button[aria-label*="language"]') ||
          el.textContent.includes('Français') || 
          el.textContent.includes('English')
        );
        
        // Créer le sélecteur de devise à gauche (après hamburger)
        let headerLocalizationLeft = document.querySelector('.header__localization-left');
        if (!headerLocalizationLeft) {
          headerLocalizationLeft = document.createElement('div');
          headerLocalizationLeft.className = 'header__localization-left';
          headerLocalizationLeft.style.cssText = `
            display: flex !important;
            align-items: center !important;
            margin: 0 8px !important;
            visibility: visible !important;
            opacity: 1 !important;
            position: relative !important;
            z-index: 10 !important;
          `;
          
          const hamburgerIcon = headerIconList.querySelector(CONFIG.SELECTORS.HAMBURGER_ICON);
          if (hamburgerIcon) {
            const hamburgerParent = hamburgerIcon.closest('li') || hamburgerIcon;
            headerIconList.insertBefore(headerLocalizationLeft, hamburgerParent.nextSibling);
          }
        }
        
        // Créer le sélecteur de langue à droite (près du panier)
        let headerLocalizationRight = document.querySelector('.header__localization-right');
        if (!headerLocalizationRight) {
          headerLocalizationRight = document.createElement('div');
          headerLocalizationRight.className = 'header__localization-right';
          headerLocalizationRight.style.cssText = `
            display: flex !important;
            align-items: center !important;
            margin: 0 8px !important;
            visibility: visible !important;
            opacity: 1 !important;
            position: relative !important;
            z-index: 10 !important;
          `;
          
          const cartIcon = headerSecondaryIconList.querySelector(CONFIG.SELECTORS.CART_ICON);
          if (cartIcon) {
            const cartIconParent = cartIcon.closest('li');
            if (cartIconParent) {
              headerSecondaryIconList.insertBefore(headerLocalizationRight, cartIconParent);
            } else {
              headerSecondaryIconList.appendChild(headerLocalizationRight);
            }
          } else {
            headerSecondaryIconList.appendChild(headerLocalizationRight);
          }
        }
        
        // Ajouter le sélecteur de devise à gauche
        if (countrySelector) {
          headerLocalizationLeft.innerHTML = '';
          const clonedCountry = cloneSelectorWithUniqueIds(countrySelector, 'popover-localization-form-country-header-left');
          headerLocalizationLeft.appendChild(clonedCountry);
        }
        
        // Ajouter le sélecteur de langue à droite
        if (localeSelector) {
          headerLocalizationRight.innerHTML = '';
          const clonedLocale = cloneSelectorWithUniqueIds(localeSelector, 'popover-localization-form-locale-header-right');
          headerLocalizationRight.appendChild(clonedLocale);
        }
        
        panelWrapper.style.display = 'none';
        
        return true;
      }
    } catch (error) {
      return false;
    }
  }
  
  // Fonction pour créer le sélecteur de devise dans le header
  async function createLocalizationInHeader() {
    try {
      const panelWrapper = await waitForElement(CONFIG.SELECTORS.PANEL_WRAPPER);
      const headerMainNav = await waitForElement(CONFIG.SELECTORS.HEADER_MAIN_NAV);
      const headerIconList = await waitForElement(CONFIG.SELECTORS.HEADER_ICON_LIST);
      const headerSecondaryNav = await waitForElement(CONFIG.SELECTORS.HEADER_SECONDARY_NAV);
      const headerSecondaryIconList = await waitForElement(CONFIG.SELECTORS.HEADER_SECONDARY_ICON_LIST);
      
      if (panelWrapper && headerMainNav && headerSecondaryNav) {
        // Récupérer tous les sélecteurs
        const allSelectors = panelWrapper.querySelectorAll('.relative');
        const countrySelector = Array.from(allSelectors).find(el => 
          el.querySelector('button[aria-label*="pays"]') || 
          el.querySelector('button[aria-label*="country"]') ||
          el.textContent.includes('EUR') || 
          el.textContent.includes('€')
        );
        
        const localeSelector = Array.from(allSelectors).find(el => 
          el.querySelector('button[aria-label*="langue"]') || 
          el.querySelector('button[aria-label*="language"]') ||
          el.textContent.includes('Français') || 
          el.textContent.includes('English')
        );
        
        // Créer le sélecteur de devise à gauche (après hamburger)
        let headerLocalizationLeft = document.querySelector('.header__localization-left');
        if (!headerLocalizationLeft) {
          headerLocalizationLeft = document.createElement('div');
          headerLocalizationLeft.className = 'header__localization-left';
          headerLocalizationLeft.style.cssText = `
            display: flex !important;
            align-items: center !important;
            margin: 0 8px !important;
            visibility: visible !important;
            opacity: 1 !important;
            position: relative !important;
            z-index: 10 !important;
          `;
          
          const hamburgerIcon = headerIconList.querySelector(CONFIG.SELECTORS.HAMBURGER_ICON);
          if (hamburgerIcon) {
            const hamburgerParent = hamburgerIcon.closest('li') || hamburgerIcon;
            headerIconList.insertBefore(headerLocalizationLeft, hamburgerParent.nextSibling);
          }
        }
        
        // Créer le sélecteur de langue à droite (près du panier)
        let headerLocalizationRight = document.querySelector('.header__localization-right');
        if (!headerLocalizationRight) {
          headerLocalizationRight = document.createElement('div');
          headerLocalizationRight.className = 'header__localization-right';
          headerLocalizationRight.style.cssText = `
            display: flex !important;
            align-items: center !important;
            margin: 0 8px !important;
            visibility: visible !important;
            opacity: 1 !important;
            position: relative !important;
            z-index: 10 !important;
          `;
          
          const cartIcon = headerSecondaryIconList.querySelector(CONFIG.SELECTORS.CART_ICON);
          if (cartIcon) {
            const cartIconParent = cartIcon.closest('li');
            if (cartIconParent) {
              headerSecondaryIconList.insertBefore(headerLocalizationRight, cartIconParent);
            } else {
              headerSecondaryIconList.appendChild(headerLocalizationRight);
            }
          } else {
            headerSecondaryIconList.appendChild(headerLocalizationRight);
          }
        }
        
        // Ajouter le sélecteur de devise à gauche
        if (countrySelector) {
          headerLocalizationLeft.innerHTML = '';
          const clonedCountry = cloneSelectorWithUniqueIds(countrySelector, 'popover-localization-form-country-header-left');
          headerLocalizationLeft.appendChild(clonedCountry);
        }
        
        // Ajouter le sélecteur de langue à droite
        if (localeSelector) {
          headerLocalizationRight.innerHTML = '';
          const clonedLocale = cloneSelectorWithUniqueIds(localeSelector, 'popover-localization-form-locale-header-right');
          headerLocalizationRight.appendChild(clonedLocale);
        }
        
        return true;
      }
    } catch (error) {
      return false;
    }
  }
  
  // Fonction pour restaurer le sélecteur de devise
  function restoreLocalizationToPanel() {
    if (window.innerWidth <= CONFIG.MOBILE_BREAKPOINT) {
      return;
    }
    
    const panelWrapper = document.querySelector(CONFIG.SELECTORS.PANEL_WRAPPER);
    if (panelWrapper) {
      panelWrapper.style.display = '';
    }
    
    const headerLocalizationLeft = document.querySelector('.header__localization-left');
    if (headerLocalizationLeft) {
      headerLocalizationLeft.innerHTML = '';
      headerLocalizationLeft.style.display = 'none';
    }
    
    const headerLocalizationRight = document.querySelector('.header__localization-right');
    if (headerLocalizationRight) {
      headerLocalizationRight.innerHTML = '';
      headerLocalizationRight.style.display = 'none';
    }
  }
  
  // Fonction principale d'initialisation
  async function init() {
    if (window.innerWidth <= CONFIG.MOBILE_BREAKPOINT) {
      const moved = await moveLocalizationToHeader();
      if (!moved) {
        setTimeout(async () => {
          await createLocalizationInHeader();
        }, 500);
      }
    }
  }
  
  // Initialiser quand le DOM est prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }
  
  // Écouter les changements de taille d'écran
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(async () => {
      if (window.innerWidth <= CONFIG.MOBILE_BREAKPOINT) {
        const moved = await moveLocalizationToHeader();
        if (!moved) {
          setTimeout(async () => {
            await createLocalizationInHeader();
          }, 500);
        }
      } else {
        restoreLocalizationToPanel();
      }
    }, 250);
  });
  
  // Forcer l'affichage du fond blanc du header lors du scroll
  function forceHeaderBackground() {
    const header = document.querySelector('.header');
    const headerWrapper = document.querySelector('.header__wrapper');
    
    if (header && headerWrapper) {
      if (window.scrollY > 10) {
        // Forcer la classe et les styles CSS
        header.classList.add('is-filled');
        headerWrapper.style.setProperty('background', 'rgba(255, 255, 255, 1)', 'important');
        headerWrapper.style.setProperty('backdrop-filter', 'blur(10px)', 'important');
        headerWrapper.style.setProperty('-webkit-backdrop-filter', 'blur(10px)', 'important');
        header.style.setProperty('--header-background-opacity', '1', 'important');
      } else {
        // Réinitialiser les styles
        header.classList.remove('is-filled');
        headerWrapper.style.removeProperty('background');
        headerWrapper.style.removeProperty('backdrop-filter');
        headerWrapper.style.removeProperty('-webkit-backdrop-filter');
        header.style.removeProperty('--header-background-opacity');
      }
    }
  }
  
  // Écouter le scroll pour forcer le fond blanc
  window.addEventListener('scroll', function() {
    forceHeaderBackground();
  });
  
  // Forcer aussi au chargement de la page
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      forceHeaderBackground();
    }, 100);
  });
  
  // Forcer aussi après un délai pour s'assurer que tout est chargé
  setTimeout(function() {
    forceHeaderBackground();
  }, 2000);
  
})(); 